import { useEffect, useState } from "react";
import { Loader2, Briefcase, MapPin } from "lucide-react";
import { rePage, reCareers } from "@/lib/docstate";
import { EnquiryForm } from "@/components/docstate/EnquiryForm";

export default function DocstateCareers() {
  const [page, setPage] = useState(null);
  const [roles, setRoles] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    rePage("careers").then(setPage).catch(() => setPage({ title: "Careers at Docstate" }));
    reCareers().then(setRoles).catch(() => setRoles([]));
  }, []);

  if (!page) return <div className="ds-bg flex min-h-screen items-center justify-center pt-16"><Loader2 className="h-8 w-8 animate-spin text-[#C9A24B]" /></div>;

  return (
    <div className="ds-bg min-h-screen" data-testid="docstate-careers">
      <section className="relative flex min-h-[42vh] items-end overflow-hidden pt-16">
        {page.hero_image && <img src={page.hero_image} alt="" className="absolute inset-0 h-full w-full object-cover opacity-40" />}
        <div className="absolute inset-0 bg-gradient-to-t from-[#0B0B0C] via-[#0B0B0C]/70 to-transparent" />
        <div className="relative mx-auto w-full max-w-7xl px-4 pb-10 sm:px-8 lg:px-12">
          {page.subtitle && <p className="ds-eyebrow">{page.subtitle}</p>}
          <h1 className="ds-display mt-2 text-4xl font-medium text-white sm:text-5xl">{page.title}</h1>
        </div>
      </section>

      <div className="mx-auto max-w-7xl px-4 py-14 sm:px-8 lg:px-12">
        {page.intro && <p className="max-w-3xl text-lg font-light text-[#C9BBB2]">{page.intro}</p>}

        <div id="roles" className="mt-12 scroll-mt-24">
          <h2 className="ds-display text-2xl text-white">Open roles</h2>
          {!roles ? (
            <div className="mt-6 flex justify-center"><Loader2 className="h-6 w-6 animate-spin text-[#C9A24B]" /></div>
          ) : roles.length ? (
            <div className="mt-6 space-y-4" data-testid="careers-list">
              {roles.map((r) => (
                <div key={r.id} className="ds-card flex flex-col gap-4 p-6 sm:flex-row sm:items-center sm:justify-between" data-testid={`career-${r.id}`}>
                  <div>
                    <h3 className="text-lg font-medium text-white">{r.title}</h3>
                    <div className="mt-2 flex flex-wrap items-center gap-4 text-xs text-[#9D8D83]">
                      {r.department && <span className="inline-flex items-center gap-1"><Briefcase className="h-3.5 w-3.5" />{r.department}</span>}
                      {r.location && <span className="inline-flex items-center gap-1"><MapPin className="h-3.5 w-3.5" />{r.location}</span>}
                      {r.type && <span className="rounded-full border border-[#C9A24B]/30 px-2 py-0.5 text-[#F3E5AB]">{r.type}</span>}
                    </div>
                    {r.description && <p className="mt-3 max-w-2xl text-sm font-light text-[#C9BBB2]">{r.description}</p>}
                  </div>
                  <a href={`mailto:${r.apply_email || "careers@docstateproperties.ae"}?subject=${encodeURIComponent("Application: " + r.title)}`} className="ds-gold-btn shrink-0 px-5 py-2.5 text-sm" data-testid={`career-apply-${r.id}`}>Apply</a>
                </div>
              ))}
            </div>
          ) : (
            <p className="mt-4 text-sm font-light text-[#9D8D83]">No open roles right now — but we always welcome exceptional talent.</p>
          )}
        </div>

        <div className="mx-auto mt-16 max-w-2xl">
          <EnquiryForm kind="career" subject="Speculative application" heading="Send us your CV" />
        </div>
      </div>
    </div>
  );
}
